import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import config from 'react-global-configuration';

import { Breadcrumbs, Paragraph, Taxonomy } from '@uncinc/react-drupal-core';

import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Share, ThemeHeader, WysiwygField, NewsletterBlock } from '../../../components';
import SwirlIllustrations from '../../../components/SwirlIllustrations';

import {
  DOMAIN_KVNL,
  PARAGRAPH_THEME_CONTENT_OVERVIEW,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../config/constants';

import './style.scss';

const NodeOverviewPage = ({ entity, className }) => {
  const theme = entity.getIn(['field_theme', 0, 'entity']);

  const addSwirls = entity.getIn(['field_add_swirls', 0, 'value'], false);
  const isWizardOverviewPage = entity.get('field_paragraphs', List()).filter((e) => {
    return e.getIn(['entity', 'type', 0, 'target_id'], null) === 'wizard_results_overview';
  }).size > 0;

  const classes = classNames(className, 'NodeOverviewPage', {
    NodeOverviewPage__no_hero: !entity.getIn(['field_hero_image', 0]),
    NodeOverviewPage__no_styled_block: isWizardOverviewPage,
    NodeMilestoneOverviewPage: addSwirls ? 'NodeMilestoneOverviewPage' : '',
  });

  return (
    <article typeof="schema:WebPage" className={classes}>
      {config.get('CURRENT_DOMAIN') === DOMAIN_KVNL && addSwirls && (
        <>
          <div className="NodeMilestoneOverviewPage__swirl__left">
            <div className="NodeMilestoneOverviewPage__swirl" />
          </div>

          <div className="NodeMilestoneOverviewPage__swirl__right">
            <div className="NodeMilestoneOverviewPage__swirl" />
          </div>
        </>
      )}
      <Container>
        {entity.getIn(['field_hero_image', 0]) && (
          <div className="NodeOverviewPage__hero">
            <Image
              className="NodeOverviewPage__hero__image"
              lazyload={false}
              includeWebP
              src={{
                [SCREEN_MOBILE]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_mobile']),
                [SCREEN_TABLET]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_tablet']),
                [SCREEN_NORMAL]: entity.getIn(['field_hero_image', 0, 'styles', 'hero_desktop']),
              }}
              alt={entity.getIn(['field_hero_image', 0, 'alt'], '')}
            />
            <div className="NodeOverviewPage__hero__arrow" />

            <SwirlIllustrations
              variant='hero'
            />
          </div>
        )}
        <div className="row">
          <div className={!addSwirls ? 'col-12 col-md-9' : 'col-12 col-md-9 offset-lg-2'}>
            <div className="NodeOverviewPage__info" id="main">
              <ThemeHeader theme={theme} />
              {!isWizardOverviewPage && !addSwirls && (
                <Breadcrumbs includeCurrent />
              )}
              <h1 property="schema:name" className="NodeOverviewPage__title">
                {entity.getIn(['title', 0, 'value'])}
              </h1>
              <WysiwygField
                property="schema:text"
                className="NodeOverviewPage__body subheading2"
                html={entity.getIn(['body', 0, 'processed'], '')}
              />
              {!isWizardOverviewPage && (
                <div className="NodeOverviewPage__info__arrow" />
              )}

            </div>
          </div>
        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="NodeOverviewPage__paragraphs">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            const type = paragraph.getIn(['entity', 'type', 0, 'target_id'], '');

            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
                theme={type === PARAGRAPH_THEME_CONTENT_OVERVIEW && theme}
              />
            );
          })}
        </div>
      ) : null}

      {theme && (
        <Container>
          <div className="row">
            <div className='col-12'>
              <Taxonomy
                id={theme.getIn(['tid', 0, 'value'])}
                entity={theme}
                viewMode='card'
              />
            </div>
          </div>
        </Container>
      )}

      <Container>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <Share pageTitle={entity.getIn(['title', 0, 'value'], '')} />
          </div>
        </div>
      </Container>

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </article>
  );
};

export default NodeOverviewPage;
